export default {
  STATIC: 'STATIC',
  SUBSCRIBER_FAVOURITE: 'SUBSCRIBER_FAVOURITE',
  SUBSCRIBER_WATCHED: 'SUBSCRIBER_WATCHED',
  SUBSCRIBER_RECORDING: 'SUBSCRIBER_RECORDING',
  RECOMMENDATION: 'RECOMMENDATION',
  RELATED_CLIPS: 'RELATED_CLIPS',
  CUSTOM: 'CUSTOM',
};
